<template>
  <div class="cover-branding">
    <img class="cover-branding-img" :alt="brand.title" :src="brand.graphic">
  </div>
</template>

<script>
export default {
  name: "Branding",
  props: ["brand"]
}
</script>

<style lang="scss" scoped>
  #app {
    .page-cover, .page-back-cover {
      .cover-branding {
        max-width: 35%;
        height: 100%;
        margin: 0 2%;
        display: flex;
        align-items: center;
        justify-content: center;
        .cover-branding-img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .index-section {
      height: 100%;
      .cover-branding {
        .cover-branding-link {
          display: flex;
          justify-content: center;
          img {
            max-width: 100%;
            max-height: 7em;
          }
        }
      }
    }
  }
</style>